
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { SemesterTypeResponse } from "../../models/dtos";

export const semesterTypesApi = createApi({
  reducerPath: 'semesterTypesApi',
  baseQuery: baseAuthQuery('SemesterTypes'),
  tagTypes: ['SemesterType'],
  endpoints: (builder) => ({
    getSemesterTypes: builder.query<ApiResponse<SemesterTypeResponse[]>, void>({
      query: () => "",
      providesTags: ['SemesterType'],
    }),
    getSemesterTypeById: builder.query<ApiResponse<SemesterTypeResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['SemesterType'],
    }),
    updateSemesterType: builder.mutation<ApiResponse<SemesterTypeResponse>, Partial<SemesterTypeResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['SemesterType'],
    }),
    deleteSemesterType: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['SemesterType'],
    }),
  }),
});
